import axios from "axios";

const endpoint_url = "/message/whatsappMessageTemplate/list";

const getWhatsappMessageTemplateList = (parameters) => {
  return new Promise((resolve, reject) => {
    axios
      .get(endpoint_url, { params: parameters })
      .then((response) => resolve(response.data))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

export default getWhatsappMessageTemplateList;
